
const base = window.siteHandle;
export const API_URL = window.EXPORT_TYPE_SCORM ? './api' : `/${base}/api`;